import {Component, ChangeDetectionStrategy} from '@angular/core';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';

@Component({
    selector: 'app-disasterrelief',
    templateUrl: './disasterrelief.component.html',
    styleUrls: ['./disasterrelief.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisasterreliefComponent {

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/1GlIAxcW2gI',
      title: 'Disaster Relief - Change of Mailing Address',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/61U7eTv6mRM',
      title: 'Misfortune and Calamity: Notices of Assessed Value Change Explained',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/8pYFZRpwrkQ',
      title: 'LA County Assessor Jeff Prang\'s Disaster Relief Webinar',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/hg44ABoSdb0',
      title: 'Online Misfortune and Calamity Claim Form - How to Apply for Disaster Relief',
      powerpoint: null
    },
    {
      url: 'https://www.youtube.com/embed/CzK43sDTUMw',
      title: 'Spectrum News Interview with Assessor Jeff Prang',
      powerpoint: null
    }

  ];

  constructor() { }

}
